/** The Sksnap app logo (the same paper-plane mark as the Android app). `size` is the pixel size; corners are rounded like an app icon. */
export default function SkLogo({ size = 40, className = "" }: { size?: number; className?: string }) {
  return (
    <img
      src="/icon-192.png"
      alt="Sksnap"
      width={size}
      height={size}
      className={`rounded-[22%] ${className}`}
      style={{ width: size, height: size }}
    />
  );
}
